/**
 * Store Memory Types
 * Types for store-specific persistent notes used by branch managers
 */

export type StoreMemoryCategory = 'priorities' | 'issues' | 'goals' | 'general';

export interface StoreMemory {
  id: string;
  storeId: string;
  category: StoreMemoryCategory | null;
  content: string;
  priority: number;
  isActive: boolean;
  createdBy: string;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface StoreMemoryWithCreator extends StoreMemory {
  creator: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  };
  updater?: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  } | null;
}

export interface CreateStoreMemoryRequest {
  storeId: string;
  content: string;
  category?: StoreMemoryCategory;
  priority?: number;
}

export interface UpdateStoreMemoryRequest {
  content?: string;
  category?: StoreMemoryCategory;
  priority?: number;
  isActive?: boolean;
}

export interface StoreMemoryListParams {
  storeId?: string;
  category?: StoreMemoryCategory;
  includeInactive?: boolean;
  limit?: number;
  offset?: number;
}

export interface StoreMemoryListResponse {
  memories: StoreMemoryWithCreator[];
  total: number;
  hasMore: boolean;
}

export interface StoreMemoryCountResponse {
  storeId: string;
  activeCount: number;
  maxNotes: number;
}

export const MAX_STORE_NOTES = 15;

export const STORE_MEMORY_CATEGORIES: StoreMemoryCategory[] = [
  'priorities',
  'issues',
  'goals',
  'general'
];
